import { useEffect, useRef, useState } from "react";
import { Loader2, MapPin } from "lucide-react";

const GEOREF_URL = "https://apis.datos.gob.ar/georef/api/direcciones";

export default function AddressAutocomplete({ value, onChange, onSelect, placeholder, testid, disabled, autoComplete }) {
  const [opciones, setOpciones] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [abierto, setAbierto] = useState(false);
  const timer = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    const cerrar = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", cerrar);
    return () => document.removeEventListener("mousedown", cerrar);
  }, []);

  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 5 || !/\d/.test(q)) { setOpciones([]); return; }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setBuscando(true);
      try {
        const params = new URLSearchParams({ direccion: q, max: "6" });
        const r = await fetch(`${GEOREF_URL}?${params}`);
        const d = await r.json();
        setOpciones(d.direcciones || []);
        setAbierto(true);
      } catch { setOpciones([]); }
      finally { setBuscando(false); }
    }, 400);
    return () => clearTimeout(timer.current);
  }, [value]);

  const elegir = (d) => {
    const nombre = d.nomenclatura;
    onChange(nombre);
    onSelect?.({ direccion: nombre, lat: d.ubicacion.lat, lng: d.ubicacion.lon });
    setOpciones([]);
    setAbierto(false);
  };

  return (
    <div ref={boxRef} className="relative">
      <div className="relative">
        <input
          data-testid={testid}
          type="text"
          value={value}
          disabled={disabled}
          autoComplete={autoComplete}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => opciones.length > 0 && setAbierto(true)}
          placeholder={placeholder}
          className="w-full bg-panel border border-line focus:border-brand rounded-md pl-3 pr-9 py-2.5 text-sm text-white placeholder:text-zinc-600 outline-none transition-colors"
        />
        <div className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500">
          {buscando ? <Loader2 className="w-4 h-4 animate-spin" /> : <MapPin className="w-4 h-4" />}
        </div>
      </div>
      {abierto && opciones.length > 0 && (
        <div data-testid={`${testid}-opciones`} className="absolute z-30 left-0 right-0 mt-1 bg-[#151517] border border-line rounded-md shadow-xl overflow-hidden">
          {opciones.map((d, i) => (
            <button
              key={i}
              type="button"
              data-testid={`${testid}-opcion-${i}`}
              onClick={() => elegir(d)}
              className="w-full text-left px-3 py-2.5 text-xs text-zinc-300 hover:bg-brand/10 hover:text-white border-b border-line/50 last:border-0 transition-colors"
            >
              {d.nomenclatura}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
